export default "__VITE_ASSET__BCNu8ajE__"